import { render, staticRenderFns } from "./IconTextButton.vue?vue&type=template&id=f097bde0&scoped=true"
import script from "./IconTextButton.vue?vue&type=script&lang=js"
export * from "./IconTextButton.vue?vue&type=script&lang=js"
import style0 from "./IconTextButton.vue?vue&type=style&index=0&id=f097bde0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f097bde0",
  null
  
)

export default component.exports